import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import moment from 'moment';

import Select from 'react-select';
import { Col, Row } from 'react-bootstrap';
import {
  Title,
  Layout,
  Explan,
  Explanation,
  Number,
  History,
  DiscountName,
  Costrow,
  Subtotal,
  Tax,
  Cost,
  Total,
  Subtotaltxt,
  Subtotaltext,
  Totaltxt,
  Totalcost,
  Table,
  SelectDesc,
  Confirmed,
} from './RequestInformation.style';
import MyPageLayout from '../../components/Layouts/MyPage/MyPageLayout.index';

import { RootState } from '../../store/reducers';
import { REQUEST_INFORMATION_REQUEST } from '../../store/actions';
import { RequestInformationStateType } from '../../store/reducers/requestInformation/requestInformationReducer';

import useAuthorizationNormal from '../../hooks/Auth/useAuthorizationNormal';
import CustomLoading from '../../components/Common/Loading/CustomLoading.index';

// import FW from '../../config/word.json';
import FS from '../../config/sentence.json';

import './RequestInformation.css';

type TargetYearMonthDataType = {
  confirmed: number;
  target_month: string;

  sub_total_list: RequestInformationSubtotalType[];
  total: number;
};
type RequestInformationSubtotalType = {
  sub_total: number;
  sub_total_name: string;
  tax_rate: number;
  request_information: RequestInformationsPropsType[];
};
type RequestInformationsPropsType = {
  id: number;
  shop_id: number;
  type: number;
  tax_rate: number;

  name: string;
  price: number;
};

interface selectInfo {
  value: string;
  label: string;
  isSelected: boolean;
}

/**
 * 請求情報画面
 */
const RequestInformation: FC = () => {
  // ライブラリーを変数に設定する
  const dispatch = useDispatch();
  // const location = useLocation();
  const history = useHistory();

  // 請求情報取得APIのデータ
  const { isRequestInformationLoaded, requestInformationData } = useSelector<RootState, RequestInformationStateType>(
    (state) => state.requestInformation,
  );

  const optionList: selectInfo[] = [];
  let defaultTargetYearMonthIndex = -1;
  const [getTargetYearMonthData, setTargetYearMonthData] = useState<TargetYearMonthDataType>();

  // ログイン認証を設定する
  useAuthorizationNormal();

  /**
   * 画面描画時の処理
   * 請求情報取得API呼び出す
   */
  useEffect(() => {
    const memberID = sessionStorage.getItem('memberID') ?? '';
    dispatch({
      type: REQUEST_INFORMATION_REQUEST,
      memberID,
      history,
    });
  }, []);

  useEffect(() => {
    if (defaultTargetYearMonthIndex >= 0) {
      const targetYearMonth = requestInformationData.request_year_month_list?.[defaultTargetYearMonthIndex];
      if (targetYearMonth) {
        setTargetYearMonthData(requestInformationData.request_year_month_data?.[targetYearMonth]);
      }
    }
  }, [isRequestInformationLoaded, defaultTargetYearMonthIndex]);

  const requestYearMonthSelectChange = (e: any): void => {
    setTargetYearMonthData(requestInformationData.request_year_month_data?.[e.value]);
  };

  if (isRequestInformationLoaded) {
    if (requestInformationData.request_year_month_list) {
      let index = -1;
      for (let i = 0; i < requestInformationData.request_year_month_list.length; i += 1) {
        optionList.push({
          label: moment(requestInformationData.request_year_month_list[i], 'YYYYMM').format('YYYY/MM'),
          value: requestInformationData.request_year_month_list[i],
          isSelected: false,
        });

        if (moment(requestInformationData.request_year_month_list[i], 'YYYYMM').isSame(moment(), 'month')) {
          index = i;
        }
      }

      if (index < 0) {
        index = 0;
      }
      defaultTargetYearMonthIndex = index;
    }
  }

  return (
    <>
      <MyPageLayout>
        <CustomLoading isLoading={!isRequestInformationLoaded} heightSize={50} isOverall />
        <Layout>
          {/* 請求情報取得APIのロードが終わった時 */}
          {isRequestInformationLoaded ? (
            <>
              {requestInformationData.result === 0 ? (
                // 請求情報取得APIの処理結果が０の場合(請求情報なし)
                <>
                  <Title>{FS.F_S_REQUEST_INFORMATION_TOTAL_ZERO_1}</Title>
                </>
              ) : requestInformationData.result === 1 ? (
                // 請求情報取得APIの処理結果が１の場合(請求情報あり)
                <>
                  {requestInformationData.request_year_month_list &&
                  requestInformationData.request_year_month_list.length > 0 ? (
                    <>
                      <Title>{FS.F_S_REQUEST_INFORMATION_TITLE}</Title>
                      <Row>
                        <SelectDesc>{FS.F_S_REQUEST_INFORMATION_SELECTION_REQUEST_YEAR_MONTH_DESCRIBUTE}</SelectDesc>
                        <Col>
                          <Select
                            instanceId="request-information-select-date"
                            classNamePrefix="request-information-select"
                            className="request-information-selectbox"
                            placeholder={FS.F_S_REQUEST_INFORMATION_SELECTION_REQUEST_YEAR_MONTH_PLACEHOLDER_TEXT}
                            options={optionList}
                            defaultValue={optionList[defaultTargetYearMonthIndex]}
                            isSearchable={false}
                            onChange={requestYearMonthSelectChange}
                          />
                        </Col>
                      </Row>
                      <br />

                      {getTargetYearMonthData ? (
                        <>
                          {getTargetYearMonthData.confirmed === 0 ? (
                            <>
                              <Confirmed>{FS.F_S_REQUEST_INFORMATION_CONFIRMED_0}</Confirmed>
                            </>
                          ) : getTargetYearMonthData.confirmed === 1 ? (
                            <>
                              <Confirmed>{FS.F_S_REQUEST_INFORMATION_CONFIRMED_1}</Confirmed>
                            </>
                          ) : getTargetYearMonthData.confirmed === 2 ? (
                            <>
                              <Confirmed>{FS.F_S_REQUEST_INFORMATION_CONFIRMED_2}</Confirmed>
                            </>
                          ) : (
                            <></>
                          )}
                          <br />

                          <Table>
                            <tbody>
                              <Total>
                                <Totaltxt colSpan={2}>合計</Totaltxt>
                                <Totalcost>¥{getTargetYearMonthData.total.toLocaleString('en')}</Totalcost>
                              </Total>
                            </tbody>
                          </Table>
                          <br />
                          <Confirmed>{FS.F_S_REQUEST_INFORMATION_DETAIL}</Confirmed>
                          <br />
                          <Table>
                            {getTargetYearMonthData.sub_total_list.map(
                              (rowItem: RequestInformationSubtotalType, rowIndex) => {
                                return (
                                  <tbody
                                    key={`request-information-list-${rowIndex.toString()}-${rowItem.sub_total_name}`}
                                  >
                                    {rowItem.request_information.map(
                                      (item: RequestInformationsPropsType, cellIndex) => {
                                        return (
                                          <tr key={`request-information-price-${cellIndex.toString()}`}>
                                            {item.type === 8 ? (
                                              <>
                                                <Number />
                                                <History>
                                                  <DiscountName># {item.name}</DiscountName>
                                                </History>
                                                <Costrow />
                                              </>
                                            ) : (
                                              <>
                                                <Number>
                                                  {item.price < 0 ? <>#</> : rowIndex > 0 ? <>*</> : <></>}
                                                </Number>
                                                <History>{item.name}</History>
                                                <Costrow>
                                                  {item.price < 0 ? (
                                                    <>-¥{(item.price * -1).toLocaleString('en')}</>
                                                  ) : item.price > 0 ? (
                                                    <>¥{item.price.toLocaleString('en')}</>
                                                  ) : (
                                                    <></>
                                                  )}
                                                </Costrow>
                                              </>
                                            )}
                                          </tr>
                                        );
                                      },
                                    )}
                                    <Subtotal>
                                      <Number> </Number>
                                      <Subtotaltxt>
                                        <Subtotaltext>
                                          {rowItem.sub_total_name.substring(0, rowItem.sub_total_name.indexOf('('))}
                                        </Subtotaltext>
                                        <Tax>
                                          {rowItem.sub_total_name.substring(rowItem.sub_total_name.indexOf('('))}
                                        </Tax>
                                      </Subtotaltxt>
                                      <Cost>¥{rowItem.sub_total.toLocaleString('en')}</Cost>
                                    </Subtotal>
                                  </tbody>
                                );
                              },
                            )}
                          </Table>
                          <Explan>表示されている金額はすべて総額表示(税込)となります。</Explan>
                          <Explanation>*は軽減税率対象品目です。</Explanation>
                          <Explanation>#は該当月の表示価格から割り引かれる金額です。</Explanation>
                          <Explanation>
                            日割り等で割引金額が表示価格を上回った場合、割引金額の上限は表示価格となります。
                          </Explanation>
                          {getTargetYearMonthData.confirmed === 0 || getTargetYearMonthData.confirmed === 1 ? (
                            <>
                              <Explanation>{FS.F_S_REQUEST_INFORMATION_FOOTNOTE_1_1}</Explanation>
                              <Explanation>{FS.F_S_REQUEST_INFORMATION_FOOTNOTE_1_2}</Explanation>
                              <Explanation>{FS.F_S_REQUEST_INFORMATION_FOOTNOTE_1_3}</Explanation>
                            </>
                          ) : (
                            <>
                              <Explanation>{FS.F_S_REQUEST_INFORMATION_FOOTNOTE_2_1}</Explanation>
                              <Explanation>{FS.F_S_REQUEST_INFORMATION_FOOTNOTE_2_2}</Explanation>
                              <Explanation>{FS.F_S_REQUEST_INFORMATION_FOOTNOTE_2_3}</Explanation>
                              <Explanation>{FS.F_S_REQUEST_INFORMATION_FOOTNOTE_2_4}</Explanation>
                            </>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  ) : (
                    <>
                      <Title>{FS.F_S_REQUEST_INFORMATION_TOTAL_ZERO_1}</Title>
                    </>
                  )}
                </>
              ) : requestInformationData.result === 11 ? (
                // 請求情報取得APIの処理結果が11の場合
                <>
                  <Title>{FS.F_S_REQUEST_INFORMATION_RESULT_11}</Title>
                </>
              ) : requestInformationData.result === 12 ? (
                // 請求情報取得APIの処理結果が12の場合
                <>
                  <Title>{FS.F_S_REQUEST_INFORMATION_RESULT_12}</Title>
                </>
              ) : requestInformationData.result === 13 ? (
                // 請求情報取得APIの処理結果が13の場合
                <>
                  <Title>{FS.F_S_REQUEST_INFORMATION_RESULT_13}</Title>
                </>
              ) : requestInformationData.result === 99 ? (
                // 請求情報取得APIの処理結果が99の場合
                <>
                  <Title>{FS.F_S_REQUEST_INFORMATION_RESULT_99}</Title>
                </>
              ) : (
                // その他の場合
                <>
                  <Title>{FS.F_S_REQUEST_INFORMATION_RESULT_OTHER}</Title>
                </>
              )}
            </>
          ) : (
            <></>
          )}
        </Layout>
      </MyPageLayout>
    </>
  );
};

export default RequestInformation;
